import { Box, Pagination, Select, MenuItem, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaginationBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '10px',
  backgroundColor: theme.palette.background.formTables,
  borderTop: `3px solid ${theme.palette.primary.main}`,
  borderBottomRightRadius: '5px',
  borderBottomLeftRadius: '5px',
  padding: '10px',
  gap: 2,
  color: theme.palette.primary.main,
}));

const PaginationTable = ({
  totalPages,
  totalCount,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 15, 25, 50, 100, 200, 500],
  sx = {},
  ...props
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <StyledPaginationBox sx={sx} {...props}>
      <Pagination
        sx={{
          order: { xs: 3, sm: 1 },
          '& .MuiPaginationItem-root': {
            fontSize: { xs: '14px', md: '16px' },
          },
        }}
        count={totalPages}
        shape="rounded"
        page={page}
        onChange={onPageChange}
        size={isSmallScreen ? 'small' : 'medium'}
      />

      <Box
        sx={{
          order: { xs: 1, sm: 2 },
          fontSize: { xs: '14px', md: '16px' },
          textAlign: 'center',
        }}
      >
        Registros: {totalCount}
      </Box>

      {onRowsPerPageChange && (
        <Box
          sx={{
            order: { xs: 2, sm: 3 },
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: { xs: '14px', md: '16px' },
            ml: 2,
          }}
        >
          <span>Items:</span>
          <Select
            value={rowsPerPage}
            onChange={onRowsPerPageChange}
            size="small"
            sx={{
              fontSize: { xs: '14px', md: '16px' },
              minWidth: 70,
            }}
          >
            {rowsPerPageOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    </StyledPaginationBox>
  );
};

export default PaginationTable;
